import AddressForm from "components/Addresses/components/AddressForm";
import AddressParsePanel from "components/Addresses/components/AddressParsePanel";
import BooksAddFundsPanel from "../Books/components/BooksAddFunds/BooksAddFundsPanel";
import BooksAddOverpayFundsPanel from "../Books/components/BooksAddOverpayFundsPanel/BooksAddOverpayFundsPanel";
import BooksAddPayPalFundsPanel from "../Books/components/BooksAddPayPalFundsPanel/BooksAddPayPalFundsPanel";
import BooksAddStripeFundsPanel from "../Books/components/BooksAddStripeFundsPanel/BooksAddStripeFundsPanel";
import PassportFormPanel from "../Books/components/BooksPassportsList/PassportFormPanel";
import PassportViewPanel from "../Books/components/BooksPassportsList/PassportViewPanel";
import BooksUsdtDepositPanel from "../Books/components/BooksUsdtDeposit/BooksUsdtDepositPanel";
import BooksVoucherFundsPanel from "../Books/components/BooksVoucherFunds/BooksVoucherFundsPanel";
import ContainerDetailedPanel from "../Containers/components/ContainerDetailedPanel/ContainerDetailedPanel";
import ExpectedItemPanel from "../Expected/components/ExpectedItemPanel/ExpectedItemPanel";
import ExpectedPackOptions from "../Expected/components/ExpectedPackOptions/ExpectedPackOptions";
import ExpectedServiceRequest from "../Expected/components/ExpectedServiceRequest/ExpectedServiceRequest";
import HelpPanel from "../Help/components/HelpPanel/HelpPanel";
import InboundAddressFormPanel from "../Inbound/components/InboundAddressFormPanel/InboundAddressFormPanel";
import InboundImportPanel from "../Inbound/components/InboundImportPanel/InboundImportPanel";
import InboundParsePanel from "../Inbound/components/InboundParsePanel/InboundParsePanel";
import InboundShipmentPanel from "../Inbound/components/InboundShipmentPanel/InboundShipmentPanel";
import ParcelDetailedPanel from "../History/components/Parcel/ParcelDetailedPanel";
import ManifestDetailPanel from "../History/components/Week/ManifestDetailPanel";
import ChangingAddressPanel from "../Outgoing/components/ChangingAddressPanel/ChangingAddressPanel";
import ConsolidationPanel from "../Outgoing/components/ConsolidationPanel/ConsolidationPanel";
import DeliveryMethodsPanel from "../Outgoing/components/DeliveryMethodsPanel/DeliveryMethodsPanel";
import DemoNotFinishedPanel from "../Outgoing/components/DemoOutgoing/DemoNotFinishedPanel";
import NotFinishedPanel from "../Outgoing/components/NotFinishedPanel/NotFinishedPanel";
import PackingGradePanel from "../Outgoing/components/PackingGradePanel/PackingGradePanel";
import PayAllPanel from "../Outgoing/components/PayAllPanel/PayAllPanel";
import PaymentDetailsConfirmationPanel from "../Outgoing/components/PaymentDetailsConfirmationPanel/PaymentDetailsConfirmationPanel";
import ProhibitedGoodsPanel from "../Outgoing/components/ProhibitedGoodsPanel/ProhibitedGoodsPanel";
import ReviewAndPayPanel from "../Outgoing/components/ReviewAndPayPanel/ReviewAndPayPanel";
import ShopifyExportPanel from "../Shopify/components/ShopifyExportPanel/ShopifyExportPanel";
import ShopifyItemFormPanel from "../Shopify/components/ShopifyItemPanel/ShopifyItemFormPanel";
import ShopifyItemViewPanel from "../Shopify/components/ShopifyItemPanel/ShopifyItemViewPanel";
import ShopifyProfileFormPanel from "../Shopify/components/ShopifyProfilesList/ShopifyProfileFormPanel";
import ShopifyProfileViewPanel from "../Shopify/components/ShopifyProfilesList/ShopifyProfileViewPanel";
import PackOptions from "../Storage/components/PackOptions/PackOptions";
import ServiceRequest from "../Storage/components/ServiceRequests/ServiceRequest";
import StorageItemInfo from "../Storage/components/StorageItemPanel/StorageItemPanel";
import PrintUserFormPanel from "../Tools/components/PrintUsersList/PrintUserFormPanel";
import PrintUserPasswordPanel from "../Tools/components/PrintUsersList/PrintUserPasswordPanel";
import PrintUserViewPanel from "../Tools/components/PrintUsersList/PrintUserViewPanel";

export const PANEL_COMPONENTS = {
  PAY_ALL: PayAllPanel,
  MANIFEST_DETAIL: ManifestDetailPanel,
  CONTAINER_DETAILED: ContainerDetailedPanel,
  ADDRESS_FORM: AddressForm,
  ADDRESS_PARSE: AddressParsePanel,
  STORAGE_ITEM: StorageItemInfo,
  NOT_FINISHED: NotFinishedPanel,
  DEMO_NOT_FINISHED: DemoNotFinishedPanel,
  SERVICE_REQUEST: ServiceRequest,
  WAITING_PAYMENT: ConsolidationPanel,
  PACK_OPTIONS: PackOptions,
  IN_PROGRESS: ConsolidationPanel,
  DELIVERY_METHODS: DeliveryMethodsPanel,
  PROHIBITED_FOUND: ProhibitedGoodsPanel,
  CHANGING_ADDRESS: ChangingAddressPanel,
  REVIEW_AND_PAY: ReviewAndPayPanel,
  CONFIRM_PAYMENT_DETAILS: PaymentDetailsConfirmationPanel,
  PARCEL_DETAILED: ParcelDetailedPanel,
  PACKING_GRADE: PackingGradePanel,
  HELP_PANEL: HelpPanel,
  EXPECTED_ITEM: ExpectedItemPanel,
  EXPECTED_SERVICE_REQUEST: ExpectedServiceRequest,
  EXPECTED_PACK_OPTIONS: ExpectedPackOptions,
  INBOUND_SHIPMENT: InboundShipmentPanel,
  INBOUND_ADDRESS_FORM: InboundAddressFormPanel,
  INBOUND_IMPORT: InboundImportPanel,
  INBOUND_PARSE: InboundParsePanel,
  BOOKS_ADD_FUNDS: BooksAddFundsPanel,
  BOOKS_ADD_PAYPAL_FUNDS: BooksAddPayPalFundsPanel,
  BOOKS_ADD_STRIPE_FUNDS: BooksAddStripeFundsPanel,
  BOOKS_ADD_OVERPAY_FUNDS: BooksAddOverpayFundsPanel,
  BOOKS_VOUCHER_FUNDS: BooksVoucherFundsPanel,
  BOOKS_USDT_DEPOSIT: BooksUsdtDepositPanel,
  PASSPORT_FORM: PassportFormPanel,
  PASSPORT_VIEW: PassportViewPanel,
  SHOPIFY_PROFILE_VIEW: ShopifyProfileViewPanel,
  SHOPIFY_PROFILE_FORM: ShopifyProfileFormPanel,
  SHOPIFY_ITEM_VIEW: ShopifyItemViewPanel,
  SHOPIFY_ITEM_FORM: ShopifyItemFormPanel,
  SHOPIFY_EXPORT: ShopifyExportPanel,
  PRINT_USER_VIEW: PrintUserViewPanel,
  PRINT_USER_FORM: PrintUserFormPanel,
  PRINT_USER_PASSWORD: PrintUserPasswordPanel,
};

export const hasIgnoredClass = (
  element: EventTarget,
  ignoredClass: string,
): boolean => {
  if (!(element instanceof HTMLElement)) return false;

  const classList = element.classList;

  return Array.from(classList).some((c) => c.includes(ignoredClass));
};

export const isInIgnoredElement = (
  element: EventTarget | null,
  ignoredClass: string,
): boolean => {
  let currentElement = element as HTMLElement | null;

  while (currentElement) {
    if (hasIgnoredClass(currentElement, ignoredClass)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }

  return false;
};
